import { Button, Card, SendIcon, TextArea } from "@codat/orchard-ui";
import React, { useEffect, useRef } from "react";

import styles from "./PromptBox.module.scss";

interface PromptBoxProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  formRef: React.RefObject<HTMLFormElement>;
  isLoading: boolean;
}

const DEFAULT_HEIGHT = "2.25rem";

const adjustHeight = (
  textareaRef: React.RefObject<HTMLTextAreaElement | null>
) => {
  const textarea = textareaRef.current;
  if (textarea) {
    textarea.style.height = DEFAULT_HEIGHT;
    textarea.style.height = `${textarea.scrollHeight}px`;
  }
};

const PromptBox = ({ value, onChange, formRef, isLoading }: PromptBoxProps) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    adjustHeight(textareaRef);
  }, [value]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      formRef.current?.requestSubmit();
    }
  };

  return (
    <Card size="small" className={styles.promptBox}>
      <TextArea
        ref={textareaRef}
        containerClassName={styles.inputWrapper}
        className={styles.textInput}
        label="Prompt"
        showLabel={false}
        placeholder="Ask about this report"
        style={{
          height: DEFAULT_HEIGHT,
        }}
        onKeyDown={handleKeyDown}
        onChange={(...args) => {
          onChange(...args);
          adjustHeight(textareaRef);
        }}
        value={value}
        data-testid="prompt-input"
      />
      <Button
        className={styles.submitButton}
        label="Send message"
        variant="primary"
        type="submit"
        isLoading={isLoading}
      >
        <SendIcon />
      </Button>
    </Card>
  );
};

export default PromptBox;
